import { memo } from "react";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const Amenity = ({ headline, names = [] }) => {
	if (!headline && names.length === 0) {
		return false;
	}

	return (
		<div className="amenity" data-testid="amenity">
			{headline && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="amenity__title"
					data-testid="amenity-title"
				>
					{headline}
				</Typography>
			)}
			{names.length > 0 && (
				<ul className="amenity__items" data-testid="amenity-items">
					{names?.map((item, index) => (
						<li
							key={item}
							className={`amenity__item ${
								index < Math.ceil(names.length / 2)
									? "amenity__item--left"
									: "amenity__item--right"
							}`}
						>
							<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR}>{item}</Typography>
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

Amenity.propTypes = {
	headline: PropTypes.string,
	names: PropTypes.arrayOf(PropTypes.string),
};

export default memo(Amenity);
